import { Col, EventHandler, InputField, Label, ReactSelectBox, Row, Tooltip } from "client/CommonComponents";
import { CONSTANTS } from "client/utils/constants";
import { isNumber } from "utils";

const BudgetInformation = (props: any) => {
  const { 
    catalogItemValues, 
    catalogItemErrors, 
    handleChange, 
    priceFormat, 
    getGLCode, 
    assetTypeValue,
    onPopupFilterModel 
  } = props
  return (<>
    <p className="fs-12 mb-2"><b>Budget Information</b></p>
    <p className="fs-12 mb-2">National Accounting Price:<b>{!catalogItemValues?.nap ? 'Yes' : 'No'}</b></p>
    <Row>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <Label required data-attribute="BudgetInformation_Default_Label">Actual Price</Label>
        <Tooltip content={catalogItemValues?.actualPrice ?? ""} data-attribute="BudgetInformation_Default_Tooltip">
        <InputField
          name='actualPrice'
          placeholder="Enter Actual Price"
          onChange={(e: any) => handleChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.actualPrice}
          prefix={'$'}
          onKeyPress={(event: any) => { isNumber(event) }}
          onBlur={(event: any) => priceFormat(event, 'actualPrice')}
          disabled={catalogItemValues?.nap }
          className={catalogItemErrors?.actualPrice ? 'controlValidation' : "" }
         data-attribute="BudgetInformation_actualPrice_Input" />
        </Tooltip>
        {catalogItemErrors?.actualPrice ? <p className='validMessage'>{catalogItemErrors?.actualPrice}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <div className="label-addnew-block">
          <Label required data-attribute="BudgetInformation_Default_Label_2">Budgeting Percent</Label>
          <EventHandler onEvent={() => onPopupFilterModel('Budgeting Percent')} data-attribute="BudgetInformation_Default_EventHandler">
            <a className="fs-12">Add New</a>
          </EventHandler>
        </div>
        <Tooltip content={catalogItemValues?.budgetingPercent?.label ?? ""} data-attribute="BudgetInformation_Default_Tooltip_2">
        <ReactSelectBox
          name='budgetingPercent'
          placeholder="Select Budgeting Percent"
          options={props?.budgetingPercentOption}
          onChange={(selectedOption: any) => handleChange(selectedOption, 'budgetingPercent')}
          value={catalogItemValues?.budgetingPercent ?? ''}
          isDisabled={catalogItemValues?.nap }
          className={catalogItemErrors?.budgetingPercent ? 'controlValidation' : "" }
         data-attribute="BudgetInformation_budgetingPercent_SearchSelectBox" />
        </Tooltip>
        {catalogItemErrors?.budgetingPercent ? <p className='validMessage'>{catalogItemErrors?.budgetingPercent}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <Label required data-attribute="BudgetInformation_Default_Label_3">Budgeting Price</Label>
        <Tooltip content={catalogItemValues?.budgetingPrice ?? ""} data-attribute="BudgetInformation_Default_Tooltip_3">
        <InputField
          name='budgetingPrice'
          placeholder='Enter Budgeting Price'
          onChange={(e: any) => handleChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.budgetingPrice}
          prefix={'$'}
          onKeyPress={(event: any) => { isNumber(event) }}
          onBlur={(event: any) => priceFormat(event, 'budgetingPrice')}
          disabled={catalogItemValues?.nap }
          className={catalogItemErrors?.budgetingPrice ? 'controlValidation' : "" }
         data-attribute="BudgetInformation_budgetingPrice_Input" />
        </Tooltip>
        {catalogItemErrors?.budgetingPrice ? <p className='validMessage'>{catalogItemErrors?.budgetingPrice}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <div className="label-addnew-block">
          <Label required data-attribute="BudgetInformation_Default_Label_4">Useful Life / Lease Terms</Label>
          <EventHandler onEvent={() => onPopupFilterModel('Useful Life / Lease Terms')} data-attribute="BudgetInformation_Default_EventHandler_2">
            <a className="fs-12">Add New</a>
          </EventHandler>
        </div>
        <Tooltip content={catalogItemValues?.leaseTerm?.label ?? ""} data-attribute="BudgetInformation_Default_Tooltip_4">
        <ReactSelectBox
          name='leaseTerm'
          placeholder="Select Useful Life / Lease Terms"
          options={props?.leaseTermsOption}
          value={catalogItemValues?.leaseTerm ?? ''}
          onChange={(selectedOption: any) => handleChange(selectedOption, 'leaseTerm')}
          className={catalogItemErrors?.leaseTerm ? 'controlValidation' : "" }
         data-attribute="BudgetInformation_leaseTerm_SearchSelectBox" />
        </Tooltip>
        {catalogItemErrors?.leaseTerm ? <p className='validMessage'>{catalogItemErrors?.leaseTerm}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <Label required data-attribute="BudgetInformation_Default_Label_5">Monthly Depreciation</Label>
        <Tooltip content={catalogItemValues?.monthlyDeprecation ?? ""} data-attribute="BudgetInformation_Default_Tooltip_5">
        <InputField
          name='monthlyDeprecation'
          placeholder='Enter Monthly Depreciation'
          prefix={'$'}
          onChange={(e: any) => handleChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.monthlyDeprecation}
          onKeyPress={(event: any) => { isNumber(event) }}
          disabled={catalogItemValues?.nap }
          onBlur={(event: any) => priceFormat(event, 'monthlyDeprecation')}
          className={catalogItemErrors?.monthlyDeprecation ? 'controlValidation' : "" }
         data-attribute="BudgetInformation_monthlyDeprecation_Input" />
        </Tooltip>
        {catalogItemErrors?.monthlyDeprecation ? <p className='validMessage'>{catalogItemErrors?.monthlyDeprecation}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <Label required data-attribute="BudgetInformation_Default_Label_6">GL Code</Label>
        <Tooltip content={getGLCode(assetTypeValue) ?? ""} data-attribute="BudgetInformation_Default_Tooltip_6">
        <InputField
          name='glCode'
          placeholder='Enter GL Code'
          value={getGLCode(assetTypeValue)}
          disabled={true}
         data-attribute="BudgetInformation_glCode_Input" />
        </Tooltip>
      </Col>
      {
        props?.assetTypeValue === CONSTANTS.VEHICLE ?
          <>
          {catalogItemValues?.vehicleType?.orderRequestType === CONSTANTS.PRODUCTION_VEHICLE ?
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <Label required data-attribute="BudgetInformation_Default_Label_7">Logoed</Label>
              <Tooltip content={catalogItemValues?.logoed?.label ?? ""} data-attribute="BudgetInformation_Default_Tooltip_7">
              <ReactSelectBox
                name='logoed'
                placeholder="Select Logoed"
                options={props?.logoedOption}
                value={catalogItemValues?.logoed || ''}
                onChange={(selectedOption: any) => handleChange(selectedOption, 'logoed')}
                className={catalogItemErrors?.logoed ? 'controlValidation' : ""}
               data-attribute="BudgetInformation_logoed_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.logoed ? <p className='validMessage'>{catalogItemErrors?.logoed}</p> : ""}
            </Col>
            : null}
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="BudgetInformation_Default_Label_8">Use (Tags)</Label>
                <EventHandler onEvent={() => onPopupFilterModel('Tags')} data-attribute="BudgetInformation_Default_EventHandler_3">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.use?.label ?? ""} data-attribute="BudgetInformation_Default_Tooltip_8">
              <ReactSelectBox
                name='use'
                placeholder="Select Use"
                options={props?.useOption}
                value={catalogItemValues?.use || ''}
                onChange={(selectedOption: any) => handleChange(selectedOption, 'use')}
                className={catalogItemErrors?.use ? 'controlValidation' : ""}
               data-attribute="BudgetInformation_use_SearchSelectBox" />
              </Tooltip>
              {catalogItemErrors?.use ? <p className='validMessage'>{catalogItemErrors?.use}</p> : ""}
            </Col>
          </>
          : null
      }
    </Row>
  </>
  )
}

export default BudgetInformation;
